export default __webpack_public_path__ + "static/media/baton_placeholder.d2c6d6e4.mp4";